import "./App.css";
import { useState } from "react";
import Home from "./home/Home";
import Section from "./home/Section";
import { Routes, Route } from "react-router-dom";
import LanguageMenu from "./home/LanguageMenu";
import burgers from "./images/burgers.jpg";
import sin from "./images/sin.jpg";
import dulces from "./images/dulces.jpg";
import ensaladas from "./images/ensaladas.jpg";
import picar from "./images/picar.jpg";
import pizzas from "./images/pizzas.jpg";
import tragos from "./images/tragos.jpg";
import cervezas from "./images/cervezas.jpg";
import burgers_en from "./images/burgers_en.jpg";
import sin_en from "./images/sin_en.jpg";
import dulces_en from "./images/dulces_en.jpg";
import ensaladas_en from "./images/ensaladas_en.jpg";
import picar_en from "./images/picar_en.jpg";
import pizzas_en from "./images/pizzas_en.jpg";
import tragos_en from "./images/tragos_en.jpg";
import cervezas_en from "./images/cervezas_en.jpg";
import popupImgES from "./images/popup.jpg";
import popupImgEN from "./images/popup_en.jpg";
import kids from "./images/kids.jpg";
import kids_en from "./images/kids_en.jpg";

function App() {

  const [toggle, setToggle] = useState(true);
  const [language, setLanguage] = useState(null);

  // Menús por idioma
  const menuSectionsES = [
    { name: "burgers", route: "burgers", special: true, burger: true },
    { name: "para picar", route: "picar" },
    { name: "pizzas", route: "pizzas" },
    { name: "ensaladas", route: "ensaladas" },
    { name: "dulces", route: "dulces" },
    { name: "sin alcohol", route: "sin" },
    { name: "cervezas", route: "cervezas", special: true, beer: true },
    { name: "tragos", route: "tragos" },
    { name: "menu kids", route: "kids" },
  ];
  const menuSectionsEN = [
    { name: "burgers", route: "burgers", special: true, burger: true },
    { name: "snacks", route: "picar" },
    { name: "pizzas", route: "pizzas" },
    { name: "salads", route: "ensaladas" },
    { name: "desserts", route: "dulces" },
    { name: "non alcoholic", route: "sin" },
    { name: "beers", route: "cervezas", special: true, beer: true },
    { name: "cocktails", route: "tragos" },
    { name: "menu kids", route: "kids" },
  ];

  const imagesES = {
    burgers,
    picar,
    pizzas,
    ensaladas,
    dulces,
    sin,
    cervezas,
    tragos,
    kids,
  };
  const imagesEN = {
    burgers: burgers_en,
    picar: picar_en,
    pizzas: pizzas_en,
    ensaladas: ensaladas_en,
    dulces: dulces_en,
    sin: sin_en,
    cervezas: cervezas_en,
    tragos: tragos_en,
    kids: kids_en,
  };

  const handleSetLanguage = (lang) => {
    setLanguage(lang);
    setToggle(true); // Vuelve a mostrar el popup
  };


  const popupImg = language === "en" ? popupImgEN : popupImgES;

  // PRE-MENU DE IDIOMA
  if (!language) {
    return <LanguageMenu setLanguage={handleSetLanguage} />;
  }

  // Definimos variables a usar según idioma
  const menuSections = language === "es" ? menuSectionsES : menuSectionsEN;
  const images = language === "es" ? imagesES : imagesEN;


  // El resto del menú digital
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Home
            toggle={toggle}
            setToggle={setToggle}
            menuSections={menuSections}
            language={language}
            onLanguageReset={() => setLanguage(null)}
            popupImg={popupImg}
          />
        }
      />
      {menuSections.map((item) => (
        <Route
          key={item.route}
          path={`/${item.route}`}
          element={
            <Section
              category={images[item.route]}
              language={language}
              name={item.name}
            />
          }
        />
      ))}
    </Routes>
  );
}

export default App;